module.exports = __webpack_public_path__ + "static/media/fax.7231733f.png";